export enum AdminCacheNames {
  AUTH = 'auth',
  LAST_SEED_PRODUCT = 'lastSeedProduct',
  COOKIE_POLICY = 'cookie_policy',
}
